export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const formatTime = (date: Date): string => {
  return date.toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

export const formatDisplayDate = (date: Date): string => {
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const getNextMinute = (): Date => {
  const now = new Date();
  return new Date(now.getTime() + 60000);
};

export const getTodayMidnight = (): Date => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const createDateTime = (date: Date, timeString: string): Date | null => {
  const [hours, minutes] = timeString.split(":").map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  const dateTime = new Date(date);
  dateTime.setHours(hours, minutes, 0, 0);
  return dateTime;
};

export const isValidFutureTime = (date: Date, timeString: string): boolean => {
  if (!timeString) return false;

  const dateTime = createDateTime(date, timeString);
  if (!dateTime) return false;

  if (isSameDay(date, new Date())) {
    const nextMinute = getNextMinute();
    return dateTime >= nextMinute;
  }

  return true;
};

export const getMinTimeForDate = (date: Date): string => {
  if (isSameDay(date, new Date())) {
    return formatTime(getNextMinute());
  }
  return "00:00";
};

export const isTimeDisabled = (date: Date, hour: number): boolean => {
  if (!isSameDay(date, new Date())) return false;

  const nextMinute = getNextMinute();
  return hour < nextMinute.getHours();
};

export const isMinuteDisabled = (date: Date, hour: number, minute: number): boolean => {
  if (!isSameDay(date, new Date())) return false;

  const nextMinute = getNextMinute();
  const timeMinutes = hour * 60 + minute;
  const minAllowedMinutes = nextMinute.getHours() * 60 + nextMinute.getMinutes();

  return timeMinutes < minAllowedMinutes;
};

export const getFirstAvailableHour = (date: Date): string => {
  const defaultHour = "00";
  if (!isSameDay(date, new Date())) return defaultHour;
  return Array.from({ length: 24 }, (_, i) => i).find((hour) => !isTimeDisabled(date, hour))?.toString().padStart(2, "0") ?? defaultHour;
};

export const getFirstAvailableMinute = (date: Date, hour: number): string => {
  if (!isSameDay(date, new Date())) return "00";

  const nextMinute = getNextMinute();

  if (hour === nextMinute.getHours()) {
    const minAllowedMinutes = nextMinute.getMinutes();

    for (let i = 0; i < 12; i++) {
      const intervalMinute = i * 5;
      if (intervalMinute >= minAllowedMinutes) {
        return intervalMinute.toString().padStart(2, "0");
      }
    }
  }

  return "00";
};
